var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 87,
    fill: "#2A7F77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9404 107.701C66.9404 112.733 71.0344 116.828 76.0674 116.828C81.1004 116.828 85.1944 112.733 85.1944 107.701C85.1944 102.669 81.1004 98.5742 76.0674 98.5742C71.0344 98.5742 66.9404 102.668 66.9404 107.701ZM82.1944 107.701C82.1944 111.079 79.4454 113.828 76.0674 113.828C72.6894 113.828 69.9404 111.079 69.9404 107.701C69.9404 104.323 72.6894 101.574 76.0674 101.574C79.4454 101.574 82.1944 104.323 82.1944 107.701Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.939 73.6171C138.321 73.0661 137.374 73.1191 136.821 73.7371L115.034 98.1401L103.818 86.9241C103.232 86.3381 102.283 86.3381 101.697 86.9241C101.111 87.5101 101.111 88.4591 101.697 89.0451L114.036 101.383C114.318 101.665 114.699 101.822 115.097 101.822C115.111 101.822 115.125 101.822 115.139 101.821C115.551 101.809 115.941 101.629 116.216 101.321L139.06 75.7341C139.611 75.1171 139.557 74.1681 138.939 73.6171Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.614 105.573C114.785 105.573 114.114 106.245 114.114 107.073V122H61V52H114.114V83.427C114.114 84.255 114.785 84.927 115.614 84.927C116.443 84.927 117.114 84.255 117.114 83.427V50.5C117.114 49.672 116.443 49 115.614 49H59.5C58.671 49 58 49.672 58 50.5V123.5C58 124.328 58.671 125 59.5 125H115.614C116.443 125 117.114 124.328 117.114 123.5V107.073C117.114 106.245 116.443 105.573 115.614 105.573Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0803 69.2251C98.9093 69.2251 99.5803 68.5531 99.5803 67.7251C99.5803 66.8971 98.9093 66.2251 98.0803 66.2251H67.9443C67.1153 66.2251 66.4443 66.8971 66.4443 67.7251C66.4443 68.5531 67.1153 69.2251 67.9443 69.2251H98.0803Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9493 81.0688C99.9493 80.2408 99.2783 79.5688 98.4493 79.5688H68.3213C67.4923 79.5688 66.8213 80.2408 66.8213 81.0688C66.8213 81.8968 67.4923 82.5688 68.3213 82.5688H98.4493C99.2783 82.5688 99.9493 81.8968 99.9493 81.0688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder5);
export default __webpack_public_path__ + "static/media/order5.1c5cb8d1282ce9a271822479d3789238.svg";
export { ForwardRef as ReactComponent };